// Shared display helpers for the Profile page.

export const getInitials = (user) => {
	const first = user?.first_name?.[0] || "";
	const last = user?.last_name?.[0] || "";
	const initials = `${first}${last}`.trim();
	if (initials) return initials.toUpperCase();
	return (user?.email?.[0] || "U").toUpperCase();
};

export const formatPrice = (price, period) => {
	if (!price || Number(price) === 0) return "Free";
	const numPrice = typeof price === "string" ? parseFloat(price) : price;
	const formattedPrice = `$${numPrice.toFixed(2)}`;
	return period === "yearly"
		? `${formattedPrice}/year`
		: `${formattedPrice}/month`;
};
